import { useEffect, useState } from "react"
import "./Project.css"
import Link from "../../assets/icons/link.svg"
import Github from "../../assets/icons/github.svg"

const Project = () => {
  const [data, setData] = useState(null)
  const [filters, setFilters] = useState([
    {name: 'all', active: true, id: 0, path: ''},
    {name: 'application', active: false, id: 1, path: '#app'},
    {name: 'game', active: false, id: 2, path: '#game'},
    {name: 'landingpage', active: false, id: 3, path: '#landingpage'}
  ])

  const getData = () => {
      fetch('https://api.github.com/users/ahmedsameh74/repos?per_page=100')
    .then(res => res.json())
    .then(data => {
      const arr = []
      data.forEach(item => {
        if(item.description && item.description.includes('#')){
          // console.log(item.description)
        }
      })
      data.forEach(item => {
                if(item.homepage) {
                  if (
                    item.name !== "spotify-now-playing" &&
                    item.name !== "next" &&
                    item.name !== "csschallenge" &&
                    item.name !== 'ahmed-portfolio'
                  )
                    arr.push(item);
                  setData(arr)
                 }})
                }
    )
    .catch(err => console.log(err))
  }

  const getFilteredData = (path) => {
    fetch('https://api.github.com/users/ahmedsameh74/repos?per_page=100')
    .then(res => res.json())
    .then(data => {
      const arr = []
      data.forEach(item => {
                if(item.homepage) {
                  if (
                    item.description && item.description.includes(path)
                  )
                    arr.push(item);
                  setData(arr)
                 }})
    })
  }

  useEffect(() => {
    getData()
  },[])

  const handleFilter = (item) => {
    setFilters(filters.map(filter => {
      if(filter.name === item.name) return {...filter, active: true}
      else return {...filter, active: false}
    }))
    if(item.path === '#all'){
      getData()
    }else {
      getFilteredData(item.path)
  // const filteredData = []
  // data?.forEach(ele => {
  //   // ele.includes(`${item.path}`)
  //   if(ele.description.includes(item.path)) filteredData.push(ele)

  // })
  //     console.log(filteredData)
  //     setData(filteredData)
    }
      
  }

  return (
    <div className="section" id="projects">
      <div className="project-head">projects</div>
      <div className="project-filters">
        {filters?.map(filter => (
          <p onClick={() => handleFilter(filter)} key={filter.id} className={filter.active ? 'active' : ''}>{filter.name}</p>
        ))}
      </div>
      <div className="projects-card">
        {data &&
          data.map((item) => {
            return (
              <div key={item.id} className="card">
                <h3>{item.name}</h3>
                <p>{item.description}</p>
                <div className="card-footer">
                  <a href={item.homepage} target="_blank" rel="noreferrer">
                      <img src={Link} alt="link" />
                    Visit
                  </a>
                  <a href={item.html_url} target="_blank" rel="noreferrer">
                      <img src={Github} alt="github" />
                    Github
                  </a>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default Project